import React from 'react';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
// import { yellow } from '@mui/material/colors';


export default function ToTop() {
    const [visible, setVisible] = React.useState(false);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            //   left: 0,
        });
    };

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
        }
        else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    window.addEventListener('scroll', toggleVisible);

    return (
        <div ><VerticalAlignTopIcon className='toTop' onClick={scrollToTop} style={{display: visible ? 'inline' : 'none'}} /></div>
    );
};